// src/routes/employeeRoutes.js

import { Route } from "react-router-dom";
import ProtectedRoute from "../guards/ProtectedRoute";
import EmployeeLayout from "../pages/admin/AdminLayout";
import DailyReporting from "../pages/employeereporting/dailyreporting/page";
import EmployeeReport from "../pages/employeereport/page";
import BackdateRequest from "../pages/reporting/backdaterequest/page";
import Ticketing from "../pages/onboarddeboard/ticketing/page";
// roleId: 1=SUPERADMIN, 2=ADMIN, 3=EMPLOYEE, 4=USER, 5=HR, 6=TEAM_LEAD

const employeeRoutes = [

  // Main employee dashboard — URL: /employee-dashboard
  <Route
    key="employee-dashboard"
    path="/employee-dashboard"
    element={
      <ProtectedRoute allowedRoles={[3]}>
        <EmployeeLayout />
      </ProtectedRoute>
    }
  />,

  // Employee reporting module — URL: /employeereporting/dailyreporting
  <Route
    key="employeereporting"
    path="/employeereporting"
    element={
      <ProtectedRoute allowedRoles={[3]}>
        <EmployeeLayout />
      </ProtectedRoute>
    }
  >
    <Route path="dailyreporting" element={<DailyReporting />} />
    <Route path="employeedailyreport" element={<EmployeeReport />} />
    <Route path="backdaterequest" element={<BackdateRequest />} />
  </Route>,

  // Self ticketing for Employee — reuse existing Ticketing page
  // filtered by userId on the Ticketing page itself (self only)
  // Self ticketing for Employee — wrapped in EmployeeLayout so sidebar/navbar show
  <Route
    key="employee-ticketing"
    path="/employee-ticketing"
    element={
      <ProtectedRoute allowedRoles={[3]}>
        <EmployeeLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<Ticketing />} />
  </Route>,

];

export default employeeRoutes;
